import {Divider, Row, Col, Space, Table} from "antd";
import {Link, useLocation, useNavigate} from "react-router-dom";
import React, {useEffect, useState} from "react";
import http from "../../http";
import PartnerListPage from "../Partners/PartnerListPage";
import {useTranslation} from "react-i18next";


const CloudServiceDetailPage=(props)=>{
    const navigate = useNavigate();
    const location = useLocation();
    const {state} = location;
    const [cloud_service, setCloudService] = useState(state?.cloud_service);
    const [loading, setLoading] = useState(false);
    const { t } = useTranslation();
    const [isValidState, setValidState] = useState(!!state?.cloud_service);

    const fetchUserData=()=>{
        http.get(`/api/v1/auth/cloud_services/${cloud_service?.id}/`).then((resp)=>{
            setLoading(false);
            setCloudService(resp.data);
        }).catch((err)=>{
            setLoading(false);
        })
    }

    useEffect(()=>{
        if(!state){
            navigate('/content_not_found',{})
        }
        if(isValidState) {
            fetchUserData()
        }
    }, [state])

    const buildBreadcrumbs=()=>{
        let breadcrumbs = [];
        if(state.breadcrumbs){
            state.breadcrumbs.map((item, index)=>{
                breadcrumbs.push(
                    <><Link to={item.to} state={item.state} key={index}>{item.title}</Link> > </>
                )
            })
            breadcrumbs.push(<>{cloud_service.name}</>)
            return breadcrumbs;
        }
        return <><Link to={'/cloud_services'}>{t('menu_3')}  </Link> >  {cloud_service.name}</>;
    }
    if(isValidState) {
        return (
            <>
                <div style={{overflowY: 'auto', overflowX: 'hidden', width: '100%', height: '100%'}}>
                    <Row style={{height: '5%', color: "black", fontWeight: 'bold', justifyContent: 'space-between'}}>
                        <Col>
                            <Space>{buildBreadcrumbs()}</Space>
                        </Col>
                    </Row>
                    <Row style={{display: 'flex', flexDirection: 'column'}}>
                        <Col style={{lineHeight: '1.5rem'}}><h1>{cloud_service.name}</h1></Col>
                        <Col>{t('cloud_services_admin_name_field')} : {cloud_service.admin_name}</Col>
                        <Col>{t('cloud_services_email_field')} : {cloud_service.email}</Col>
                        <Col>{t('cloud_services_mobile_field')} : {cloud_service.mobile}</Col>
                        <Col>{t('cloud_services_category_field')} : {cloud_service.service_category}</Col>
                        <Col>{t('cloud_service_item_field')} : {cloud_service.service_item}</Col>
                    </Row>
                    <Divider/>
                    <Row style={{overflow: "hidden", height: '50%'}}>
                        <div style={{width: '100%', height: '100%'}}>
                            <PartnerListPage pageSize={6} title={t('partner_list_title')} query_params={{cloud_service_id: cloud_service.id}}/>
                        </div>
                    </Row>
                </div>
            </>

        )
    }
    else{
        return null;
    }
}

export default CloudServiceDetailPage;
